<template>
  <DetailsBidderPartner :bidderPartnerId="bidderPartnerId" />
  <ListResponsibles :bidderPartnerId="bidderPartnerId" />
</template>

<script>
import DetailsBidderPartner from '@/components/biddersPartners/DetailsBidderPartner.vue'
import ListResponsibles from '@/components/biddersPartners/ListResponsibles.vue'

export default {
  name: 'BidderDetails',

  components: {
    DetailsBidderPartner,
    ListResponsibles,
  },

  data() {
    return {
      bidderPartnerId: this.$route.params.bidderPartnerId,
    }
  },
}
</script>
